import APIService from "./api.service";


export default APIService;